import { render, staticRenderFns } from "./DynamicPageHeader.vue?vue&type=template&id=5f7b769c&scoped=true&"
import script from "./DynamicPageHeader.vue?vue&type=script&lang=js&"
export * from "./DynamicPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPageHeader.vue?vue&type=style&index=0&id=5f7b769c&scoped=true&lang=scss&"
import style1 from "./DynamicPageHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b769c",
  null
  
)

export default component.exports